import { getDefaultLogo, defaultBrands } from '@weareopenr/component-library';

export const getLogo = (url: string | null, name: string): string => {
  return url ? url : getDefaultLogo(name);
};

export const getLogoForAddon = (name: string): string | undefined => {
  const knownBrands = Object.keys(defaultBrands);
  const matchedBrand = knownBrands.find((brand) =>
    name.toLowerCase().includes(brand.toLowerCase()),
  );
  return matchedBrand ? getDefaultLogo(matchedBrand) : undefined;
};
